import React, { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import { ContentNotesProvider } from './contexts/ContentNotesContext';
import { CitySportLanding } from './pages/CitySportLanding';
import { MetroLanding } from './pages/MetroLanding';
type SportOption = 'soccer' | 'flag-football' | 'basketball';
interface AppProps {
  sport?: SportOption;
  city?: 'san-antonio' | 'las-vegas';
  showContentNotes?: boolean;
}
type View = {
  page: 'metro';
} | {
  page: 'sport';
  sport: SportOption;
};
export function App({
  sport = 'soccer',
  city = 'san-antonio',
  showContentNotes = true
}: AppProps) {
  const [view, setView] = useState<View>({
    page: 'sport',
    sport
  });
  useEffect(() => setView({
    page: 'sport',
    sport
  }), [sport, city]);
  const go = (next: View) => {
    setView(next);
    window.scrollTo({
      top: 0
    });
  };
  return <ContentNotesProvider value={showContentNotes} data-id="element-0" data-mp="28suveqfd63nb">
      {view.page === 'metro' ? <MetroLanding citySlug={city} onSelectSport={s => go({
      page: 'sport',
      sport: s
    })} data-id="element-1" data-mp="23ujlygszdv5m" /> : <CitySportLanding sportSlug={view.sport} citySlug={city} onSelectSport={s => go({
      page: 'sport',
      sport: s
    })} onOpenMetro={() => go({
      page: 'metro'
    })} data-id="element-2" data-mp="3ijfw82xf22g7" />}
      <Toaster position="top-center" data-id="element-3" data-mp="3recedkz46pg7" />
    </ContentNotesProvider>;
}